import { Transform } from "../../../../geometry/transformation";
import { sharedEditorCanvas, sharedRubberCanvas, sharedPointMapperRef, DrawOptions } from "../../interface/pointMappings";
//import { recalculateShape } from "../../util/shapeEdit";
//todo: check and remove if not needed...
import { hitStrokeCorrection, strokeCorrection } from "../../util/strokeCorrection";
import { RubberDataBase, registerInteractionHandlers, ShapeInteractionHandlers } from "../interactionManager";
import { isSamePosition } from "../../../../geometry/geometry";
import * as Global from "../../../../global"
import { hitManager } from "../hitManager"

export interface CircleRubberData extends RubberDataBase {
    points: Point2d[],
    hotspot?: Hotspot2d,
    previousRenderAngle: number,
    clockwise: boolean,
}

declare module "../interactionManager" {
  interface ShapeActionHandlersMap {
    circle: ToolEntries & {
      create: {
        rubberData: CircleRubberData;
        settings: CircleShape;
      };
    //   "edit": {
    //     rubberData: CircleRubberData;
    //     settings: CircleShape;
    //   }
    };
  }
}

export class Circle {

    // draw functions
    static render(circle: CircleShape, isSelected: boolean, lineTypes: LineType[]) {
        const drawOptions: DrawOptions = {
            color: circle.stroke,
            width: circle.strokeWidth,
        }

        const t = new Transform(circle.transformation);
        const origo = t.point2d({ x: circle.x, y: circle.y });
        sharedEditorCanvas.current.drawArc(origo, circle.radius, circle.startAngle, circle.endAngle, circle.clockwise, drawOptions);

        let hotspots: Hotspot2d[] = [];
        if (isSelected) {
            hotspots.push({ x: origo.x, y: origo.y, type: circle.type, shapeId: circle.id, innerId: 0 });
            // if (arc.startAngle === arc.endAngle) {
            //     hotspots.push({ x: begPoint.x - arc.radius * sharedPointMapperRef.current.zoom, y: begPoint.y });
            //     hotspots.push({ x: begPoint.x + arc.radius * sharedPointMapperRef.current.zoom, y: begPoint.y });
            //     hotspots.push({ x: begPoint.x, y: begPoint.y - arc.radius * sharedPointMapperRef.current.zoom });
            //     hotspots.push({ x: begPoint.x, y: begPoint.y - arc.radius * sharedPointMapperRef.current.zoom });
            // }
            // else {
            //     const x1 = begPoint.x + Math.cos(-arc.startAngle) * arc.radius * sharedPointMapperRef.current.zoom;
            //     const y1 = begPoint.y + Math.sin(-arc.startAngle) * arc.radius * sharedPointMapperRef.current.zoom;
            //     const x2 = begPoint.x + Math.cos(-arc.endAngle) * arc.radius * sharedPointMapperRef.current.zoom;
            //     const y2 = begPoint.y + Math.sin(-arc.endAngle) * arc.radius * sharedPointMapperRef.current.zoom;
            //     hotspots.push({ x: x1, y: y1 });
            //     hotspots.push({ x: x2, y: y2 });
            // }
        }

        return hotspots;
    }

    static isHit(circle: CircleShape, p: Point2d) {
        const tr = new Transform(circle.transformation);
        const p1 = tr.point2d({ x: circle.x, y: circle.y});
        const x1 = p1.x;
        const y1 = p1.y;
        //const width = 15 * 15 / sharedPointMapperRef.current.zoom;

        const dx = x1 - p.x;
        const dy = y1 - p.y;
        const lenSq = dx * dx + dy * dy;

        console.log(lenSq, circle.radius, (circle.radius - 15) * (circle.radius - 15), (circle.radius + 15) * (circle.radius + 15))
        if ((circle.radius - 15) * (circle.radius - 15) <= lenSq &&  lenSq <= (circle.radius + 15) * (circle.radius + 15)) {
            return true;
        }
        return false;
    }

    static assembleShapeToInsert<L>(shape: L): L {
        return shape;
    }

    static _calcParams(origo: Point2d, refPoint1: Point2d, refPoint2: Point2d) : { radius: number, startAngle: number, endAngle: number} {
        const dx1 = refPoint1.x - origo.x;
        const dy1 = refPoint1.y - origo.y;
        const dx2 = refPoint2.x - origo.x;
        const dy2 = refPoint2.y - origo.y;
        let startAngle = Math.atan2(dy1, dx1);
        if (startAngle < 0) startAngle = 2 * Math.PI + startAngle;
        let endAngle = Math.atan2(dy2, dx2);
        if (endAngle < 0) endAngle = 2 * Math.PI + endAngle;
        const radius = Math.hypot(origo.x - refPoint1.x, origo.y - refPoint1.y);
        console.log(radius)

        if (endAngle === startAngle) {
            endAngle = startAngle + 2 * Math.PI;
        }

        return { radius, startAngle, endAngle }
    }

}

const CircleCreateHandlers: ShapeInteractionHandlers<CircleRubberData, CircleShape> = {
    rubberInputInit: (): CircleRubberData => {
        const newRubberData: CircleRubberData = {
            points: [],
            hotspot: undefined,
            finished: false,
            previousRenderAngle: 0,
            clockwise: false,
        }

        return newRubberData;
    },
    rubberInputRenderer: (rubberPointData: CircleRubberData, cursorPosition: Point2d) => {
        const dotDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR,
            fillColor: Global.DEFAULT_RUBBERLINE_DOT_FILL_COLOR,
        }

        rubberPointData?.points.forEach(p => {
            sharedRubberCanvas.current.drawCircle(p, 5, dotDrawOptions);
        });

        const lineDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_COLOR,
        }
        const arcDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_COLOR,
        }
        const data = [...rubberPointData.points, cursorPosition];
        for (let i = 0; i < data.length; ++i) {
            if (i === 1) {
                const points = [data[0], data[1]];
                sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            }
            if (i === 2) {
                const { radius, startAngle, endAngle } = Circle._calcParams(data[0], data[1], data[2]);

                const angle = endAngle - startAngle;
                if (Math.sign(rubberPointData.previousRenderAngle) !== Math.sign(angle)
                    && Math.abs(angle) < 1
                    && Math.abs(rubberPointData.previousRenderAngle) < 1) {
                    rubberPointData.clockwise = Math.sign(angle) < 0;
                }
                rubberPointData.previousRenderAngle = angle;

                sharedRubberCanvas.current.drawArc(data[0], radius, startAngle, endAngle, rubberPointData.clockwise, arcDrawOptions);
            }
        }
    },
    rubberInputUpdater: (rubberPointData: CircleRubberData, cursorPosition: Point2d) : CircleRubberData => {
        if (rubberPointData.points.length > 0 && rubberPointData.points.length < 2) {
            if (isSamePosition(rubberPointData.points[rubberPointData.points.length - 1], cursorPosition)) {
                return rubberPointData;
            }
        }

        rubberPointData.points = [...rubberPointData.points, cursorPosition];
        rubberPointData.finished = rubberPointData.points.length === 3;

        return rubberPointData;
    },
    callback: (shape: CircleShape, rubberPointData: CircleRubberData) : GeometricShape => {
        let data: Point2d[] = [];
        for (let i = 0; i < rubberPointData?.points.length; ++i) {
            data.push(rubberPointData.points[i]);
        }
        let { radius, startAngle, endAngle } = Circle._calcParams(data[0], data[1], data[2])

        const clockwise = rubberPointData.clockwise;
        if (startAngle < 0) startAngle += 2 * Math.PI; //todo: use geometry.normalizeAngle
        if (endAngle < 0) endAngle += 2 * Math.PI;
        if (startAngle > 2 * Math.PI) startAngle -= 2 * Math.PI;
        if (endAngle > 2 * Math.PI) endAngle -= 2 * Math.PI;
        console.log("setting r", radius)
        return {
            ...shape,
            id: 0,
            strokeWidth: strokeCorrection(shape.strokeWidth, sharedPointMapperRef.current.zoom),
            hitStrokeWidth: hitStrokeCorrection(shape.hitStrokeWidth, shape.hitStrokeWidth, sharedPointMapperRef.current.zoom),
            x: rubberPointData.points[0].x,
            y: rubberPointData.points[0].y,
            radius: radius,// * sharedPointMapperRef.current.zoom,
            startAngle: startAngle,
            endAngle: endAngle,
            clockwise: clockwise,
        };
        // return recalculateShape(Circle.assembleShapeToInsert<CircleShape>({
        //     ...shape,
        //     id: 0,
        //     strokeWidth: strokeCorrection(shape.strokeWidth, sharedPointMapperRef.current.zoom),
        //     hitStrokeWidth: hitStrokeCorrection(shape.hitStrokeWidth, shape.hitStrokeWidth, sharedPointMapperRef.current.zoom),
        //     x: rubberPointData.points[0].x,
        //     y: rubberPointData.points[0].y,
        //     radius: radius,// * sharedPointMapperRef.current.zoom,
        //     startAngle: startAngle,
        //     endAngle: endAngle,
        //     clockwise: clockwise,
        // }));
    },
}

hitManager.register("circle", Circle.isHit);
registerInteractionHandlers("circle", "create", CircleCreateHandlers);